import themeConfig from 'themes/[theme]/config';

const isServer = (process.env.TARGET === 'server');
const isClient = !isServer;
const YEAR_IN_SECONDS = 31536000;

// TODO infrastructure is blocking HTTP DELETE requests to server.com/api, hence we need to use server.com/webshop/api until fixed
const clientApiBasePath = process.env.E2E_MOCKS ? '/api/v1' : '/webshop/api/v1';
const apiHost = `https://${process.env.HOST || 'localhost'}:${process.env.HTTPS_PORT || 8444}`;
export default {
  // the theme (for each retailer) specific config values
  ...themeConfig,

  // the base paths for all Raven static resources (CSS, JS, fonts, images);
  // automatically supports themes (retailers)
  staticPath: '/static',
  imagesPath: '/static/images',

  // used to verify whether the client and server are running the same code version
  buildHash: isClient ? window.RAVEN_BUILD_HASH : process.env.GIT_COMMIT_HASH,

  apiBasePrefix: '/webshop/api',
  apiHost: isClient ? '' : apiHost,
  // the base path for the REST API services; on server requests are proxied by Raven to
  // the appropriate webshop server specified via 'apiServerTarget'
  apiBasePath: isClient ? clientApiBasePath : `${apiHost}/api/v1`,
  clientApiBasePath, // should use apiBasePath in most cases!

  // the maximum time (in milliseconds) to wait for the response from REST API services
  apiTimeout: 50000,

  // backend session / BP cookie timeout [ms]
  sessionTimeout: 150 * 60 * 1000, // 2.5h

  breakpoints: {
    small: '0',
    smedium: '375px',
    medium: '480px',
    medium_large: '600px',
    large: '768px',
    xlarge: '1024px',
    xxlarge: '1920px',
  },

  gtmViewType: 'RAVEN',
  gtmWebshopVersion: isClient ? window.RAVEN_BUILD_HASH : process.env.GIT_COMMIT_HASH,
  hstsMaxAge: YEAR_IN_SECONDS,
  isServer,
};
